import { createSelector } from '@reduxjs/toolkit'
import moment from 'moment'
import { RootState } from '../store'

const groupedEnfByViolationRaw = (state: RootState) =>
  state.violationEnforcements.groupedEnforcementsByViolation.data
const groupedEnfByViolation = createSelector(
  [groupedEnfByViolationRaw],
  (data) => {
    if (Array.isArray(data)) return data
    if (data && typeof data === 'object') return Object.values(data)
    return []
  },
)
const groupedEnfByViolationLoading = (state: RootState) =>
  state.violationEnforcements.groupedEnforcementsByViolation.loading
const groupedEnfByViolationError = (state: RootState) =>
  state.violationEnforcements.groupedEnforcementsByViolation.error

interface ViolationCategorySummary {
  count: number
  category_code: string
  description: string
}
const makeViolationCategoryCountFromGroupedEnf = createSelector(
  [groupedEnfByViolation, (state, years: number) => years],
  (data, years) => {
    const categoryMap = new Map<string, ViolationCategorySummary>()

    data
      .filter((item) => moment(item.VIOL_LAST_REPORTED_DATE) > moment().subtract(years, 'years'))
      .forEach((item) => {
        // Skip items without violations or with empty violation data
        if (
          !item.VIOLATIONS ||
          item.VIOLATIONS.length === 0 ||
          !item.VIOLATIONS[0].VIOLATION_CATEGORY_CODE
        ) {
          return
        }

        const violation = item.VIOLATIONS[0]
        const categoryCode = violation.VIOLATION_CATEGORY_CODE

        if (categoryMap.has(categoryCode)) {
          // Increment count for existing category
          const existing = categoryMap.get(categoryCode)!
          existing.count++
        } else {
          // Add new category
          categoryMap.set(categoryCode, {
            count: 1,
            category_code: categoryCode,
            description: violation.VIOLATION_DESCRIPTION || '',
          })
        }
      })

    // Convert map to array and sort by count (descending)
    return Array.from(categoryMap.values()).sort((a, b) => b.count - a.count)
  },
)

export const ViolationEnforcementSelector = {
  groupedEnfByViolation: {
    data: groupedEnfByViolation,
    loading: groupedEnfByViolationLoading,
    error: groupedEnfByViolationError,
    makeViolationCategoryCountFromGroupedEnf,
  },
}
